import { render, staticRenderFns } from "./ViewMethodDataExtractionReport.vue?vue&type=template&id=32a76026&scoped=true"
import script from "./ViewMethodDataExtractionReport.vue?vue&type=script&lang=js"
export * from "./ViewMethodDataExtractionReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a76026",
  null
  
)

export default component.exports